module.exports = __webpack_public_path__ + "2d9b38f343bda7a5eabcf64df3dcbd4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/mfs.png
// module id = 1878
// module chunks = 0